import { useStaticQuery, graphql } from 'gatsby'

export const useWordPressStatistics = () => {
  const { allWordpressWpStatistic } = useStaticQuery(
    graphql`
      query {
        allWordpressWpStatistic {
          totalCount
          edges {
            node {
              type
              title
              slug
              path
              content
              wordpress_id
              featured_media {
                id
                source_url
                title
              }
              acf {
                headlines
              }
            }
          }
        }
      }
    `
  )
  return allWordpressWpStatistic.edges
}
